// @flow
import { PureComponent } from 'react';

type Props = {
    customerId: string,
};

export default class SailthruInit extends PureComponent<Props> {
    componentDidMount() {
        if (window.Sailthru && window.Sailthru.init && !window.Sailthru.initRan) {
            window.Sailthru.init({
                autoTrackPageview: false,
                customerId: this.props.customerId,
                isCustom: true,
                useStoredTags: true,
            });
            window.Sailthru.initRan = true;
        }
    }

    render() {
        return null;
    }
}
